/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {useDispatch} from 'react-redux'
import useUtils from './useUtils'
import {setTitle} from '../../redux/reducers/mainSlice'
import Pagination from '../../modules/pagination/Pagination'
import SubscriptionSkeleton from '../../modules/skeleton/SubscriptionSkeleton'
import GridView from './GridView'
import ListView from './ListView'

const currencies = [
  {name: 'US Dollar', code: 'USD'},
  {name: 'Canadian Dollar', code: 'CAD'},
]

const SubscriptionList = ({className}) => {
  const [loading, setLoading] = useState(true)
  const [gridView, setGridView] = useState(true)
  const dispatch = useDispatch()
  dispatch(setTitle('Subscription'))

  const {fetchSubscriptions, fetchBenefits} = useUtils()

  const [subscriptions, setSubscriptions] = useState()
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(12)
  const [totalPages, setTotalPages] = useState(1)

  const [pricing, setPricing] = useState('Monthly')
  const [selectedSubscription, setSelectedSubscription] = useState(true)
  const options = ['Monthly', 'Yearly']

  const [benefits, setBenefits] = useState(null)
  const [selectedCurrency, setSelectedCurrency] = useState(currencies[0]?.code)
  const [open, setOpen] = useState(false)

  const handleSelect = (currency) => {
    setSelectedCurrency(currency?.code)
    setOpen(false)
  }
  const navigate = useNavigate()

  const getSubscriptions = async () => {
    try {
      setLoading(true)
      const offset = (page - 1) * limit
      const [subsData, benefitsData] = await Promise.all([
        fetchSubscriptions(limit, offset, selectedSubscription, selectedCurrency),
        fetchBenefits(),
      ])
      setSubscriptions(subsData)
      setBenefits(benefitsData?.records)
      setTotalPages(Math.ceil(subsData?.count / limit))
    } catch (error) {
      console.error('Error loading data:', error)
    } finally {
      setLoading(false)
    }
  }

  const gridViewProps = {
    subscriptions,
    setSubscriptions,
    benefits,
    limit,
    page,
    close: () => setGridView(false),
    setLoading,
    pricing,
    selectedCurrency,
    className,
  }

  useEffect(() => {
    getSubscriptions()
  }, [limit, page, selectedSubscription, selectedCurrency])

  if (loading) return <SubscriptionSkeleton />
  return (
    <>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start'>
          <span className=' mt-1 text-muted fs-7 '>{subscriptions?.count} Items</span>
        </h3>

        <div className='mt-5 d-flex align-items-center justify-content-between w-100 flex-wrap'>
          <div className='d-flex align-items-center flex-wrap gap-3'>
            {/* <div className='currency-picker'>
              <div className='currency-toggle' onClick={() => setOpen(!open)}>
                <span className='currency-code'>{selectedCurrency}</span>
                <span className='arrow'>▼</span>
              </div>
              {open && (
                <div className='dropdown'>
                  {currencies.map((currency) => (
                    <div
                      key={currency.code}
                      className='dropdown-item'
                      onClick={() => handleSelect(currency)}
                    >
                      <span className='currency-name'>
                        {currency.name} ({currency.code})
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div> */}
            <div className='d-flex align-items-center justify-content-start flex-wrap gap-3'>
              <div className='switch-container'>
                {options.map((option) => (
                  <div
                    key={option}
                    className={`switch-option ${pricing === option ? 'active' : ''}`}
                    onClick={() => setPricing(option)}
                  >
                    {option}
                  </div>
                ))}
              </div>
            </div>

            <div>
              <select
                value={selectedSubscription === null ? '' : String(selectedSubscription)}
                className='form-select form-select-solid text-black fs-7 h-40px w-150px select2-hidden-accessible'
                onChange={(e) =>
                  setSelectedSubscription(e.target.value === '' ? null : e.target.value === 'true')
                }
                style={{backgroundColor: '#fff', border: '1px solid #e0e0e0'}}
              >
                <option value=''>All Subscriptions</option>
                <option value={true}>Active</option>
                <option value={false}>In Active</option>
              </select>
            </div>

            <div className='card-toolbar '>
              {gridView ? (
                <img
                  src={toAbsoluteUrl('media/icons/duotune/files/fil001.svg')}
                  className='me-5'
                  onClick={() => setGridView(false)}
                  style={{cursor: 'pointer', height: '24px', width: '24px'}}
                />
              ) : (
                <img
                  src={toAbsoluteUrl('media/icons/duotune/files/fil002.svg')}
                  className='me-5'
                  onClick={() => setGridView(true)}
                  style={{cursor: 'pointer', height: '24px', width: '24px'}}
                />
              )}
            </div>
          </div>
          {/* <div className='card-toolbar '>
            {gridView ? (
              <img
                src={toAbsoluteUrl('media/icons/duotune/files/fil001.svg')}
                className='me-5'
                onClick={() => setGridView(false)}
                style={{cursor: 'pointer', height: '24px', width: '24px'}}
              />
            ) : (
              <img
                src={toAbsoluteUrl('media/icons/duotune/files/fil002.svg')}
                className='me-5'
                onClick={() => setGridView(true)}
                style={{cursor: 'pointer', height: '24px', width: '24px'}}
              />
            )}
            <a
              onClick={() => navigate('/subscriptionlist/addSubscription')}
              className='btn btn-sm btn-primary'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
              Add Subscription
            </a>
          </div> */}
        </div>
      </div>

      {subscriptions?.count === 0 && (
        <div className='d-flex h-100 flex-column mt-20 '>
          <div className='card shadow  w-sm-100 w-md-75 mx-auto p-5 py-20'>
            <div className='card-body text-center'>
              <span className='svg-icon svg-icon-2hx svg-icon-info mb-5'>
                <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-2x' />
              </span>
              <h4 className='mb-1'>No Records Found</h4>
              <span>Add Subscriptions to see the records.</span>
            </div>
          </div>
        </div>
      )}

      <div className='row gx-10 gy-10 py-10'>
        {gridView ? <GridView {...gridViewProps} /> : <ListView {...gridViewProps} />}
        <div className='d-flex align-items-center justify-content-between pb-5 ps-10 pe-5'>
          <div className='d-flex align-items-center gap-3'>
            <span className='fs-6 '>Show</span>
            <div>
              <select
                defaultValue={limit}
                className='form-select select2-hidden-accessible'
                onChange={(e) => {
                  setPage(1)
                  setLimit(e.target.value)
                }}
                style={{backgroundColor: 'white'}}
              >
                <option>12</option>
                <option>24</option>
                <option>60</option>
                <option>100</option>
              </select>
            </div>
          </div>
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
        </div>
      </div>
    </>
  )
}
export default SubscriptionList
